import React from 'react';
import './About.css'

const About = () => {
    return (
        <div className='about'>
            <h2 className='text-6xl'>About</h2>
            <p>This is about section</p>
        </div>
    );
};

export default About;